<div class="modal-dialog ai-markers-dialog-container">
	<div class="modal-content" cdkTrapFocus>
		<div class="goreact-modal-header">
			<span class="header-label">
				<h4 class="modal-title">
					<i class="ficon-sparkles" aria-hidden="true"></i>
					<span translate="chart_title-ai_prompt"></span>
				</h4>
			</span>
			<button type="button" class="close-btn" (click)="cancel()"
					attr.aria-label="{{ 'common_close' | translate }}">
				<i class="ficon-app-x"></i>
			</button>
		</div>
		<section>
			<div *ngIf="!aiConfigFlag; else aiConfig" class="goreact-modal-body old-style" [ngClass]="{ 'collapsed': (showAi$ | async) === false }">
				<div>{{ 'activity-editor-new_ai-markers-modal-sub-title' | translate }}</div>
				<hr *ngIf="aiLanguageFlag"/>
				<ng-container *ngIf="aiLanguageFlag">
					<div class="section-container transcript-container">
						<div class="container-header">
							<strong>{{ 'feedback-session-feedback-display_transcript-header' | translate }}</strong>
						</div>
						<span class="transcript-language">
						<span
							class="language-label"
							translate="activity-editor-new_ai-markers-modal-transcript-language">
						</span>
						<mat-form-field goSelect>
							<mat-select
								disableOptionCentering
								panelClass="offsetPanel"
								class="language-selector"
								[ngModel]="selectedLanguage$ | async"
								(ngModelChange)="selectedLanguage$.next($event)">
								<mat-option
									*ngFor="let language of languages$ | async"
									[value]="language">
									{{ language.language_name }}
								</mat-option>
							</mat-select>
							<mat-icon matIconSuffix class="ficon-app-chevron-down"></mat-icon>
						</mat-form-field>
					</span>
					</div>

				</ng-container>
				<ng-container *ngIf="(loading$ | async) === false; else loading">
					<div class="section-container markers-container"
						 [ngClass]="{'has-error': (selectedCount$ | async) > AiMarkersLimit}">
						<div class="container-header">
							<strong>{{ 'activity-editor-new_ai-markers-modal-ai-markers' | translate }}</strong>
							<div *teaseWall="toggleTeaseConfig; of: loading$">
								<mat-slide-toggle
									[hideIcon]="true"
									(change)="toggleAiMarkers($event)"
									[checked]="true"
									color="primary"
									class="ai-comments-toggle">
									<span *ngIf="showAi$ | async">{{ 'common_on' | translate }}</span>
									<span *ngIf="(showAi$ | async) === false">{{ 'common_off' | translate }}</span>
								</mat-slide-toggle>
							</div>
						</div>
						<p translate="activity-editor-new_ai-markers-modal-description"
						   [translateParams]="{ limit: AiMarkersLimit }">
						</p>

						<ng-container *ngIf="showAi$ | async">
							<div *ngIf="useTypes$ | async" class="use-types-container">
								<mat-form-field goSelect>
									<mat-label>{{ 'activity-editor-new_ai-markers-modal-use-type' | translate }}</mat-label>
									<mat-select
										disableOptionCentering
										panelClass="offsetPanel"
										[ngModel]="useTypeFilter$ | async"
										(selectionChange)="useTypeFilter$.next($event.value)">
										<mat-option
											*ngFor="let u of useTypes$ | async"
											[value]="u.use_type_id">
											{{ u.name }}
										</mat-option>
									</mat-select>
									<mat-icon matIconSuffix class="ficon-app-chevron-down"></mat-icon>
								</mat-form-field>
								<span class="selected-count"
								 	*ngIf="(selectedCount$ | async) > 0"
								 	[ngClass]="{'has-error': (selectedCount$ | async) > AiMarkersLimit }">({{ selectedCount$ | async }})</span>
							</div>

							<div class="markers" [style.overflow-y]="shouldTease ? 'hidden':'auto'">
								<div class="marker-item" *ngFor="let prompt of filteredPrompts$ | async">
									<ng-container *ngIf="!shouldTease">
										<mat-checkbox
											color="primary"
											[checked]="(checkedIds$ | async).has(prompt.id)"
											(change)="selectPrompt($event.checked, prompt)"
											aria-label="{{ markerAriaLabel(prompt) }}">
											<marker
												[marker]="markerInput(prompt)"
												[aiStyle]="true"
												[withName]="true">
											</marker>
											<div class="prompt-description">{{ prompt.description }}</div>
										</mat-checkbox>
									</ng-container>

									<ng-container *ngIf="shouldTease">
										<div class="teased-marker-item">
											<div *teaseWall="checkboxTeaseConfig; of: loading$">
												<mat-checkbox
													color="primary"
													class="checkbox-to-blur"
													[checked]="(checkedIds$ | async).has(prompt.id)"
													[disabled]="true"
													aria-label="{{ markerAriaLabel(prompt) }}">
												</mat-checkbox>
											</div>
											<div class="marker-and-description">
												<marker
													[marker]="markerInput(prompt)"
													[aiStyle]="true"
													[withName]="true">
												</marker>
												<div class="prompt-description">{{ prompt.description }}</div>
											</div>
										</div>
									</ng-container>
								</div>
							</div>

							<div *ngIf="!shouldTease" class="ai-marker-form-link">
								<span>
									<i class="ficon-lightbulb-o"></i>
									{{ 'activity-editor-new_ai-markers-modal-request-feedback-text' | translate }}
									<a
										href="https://forms.office.com/Pages/ResponsePage.aspx?id=pc7Ek96TuEyKKMAbn5USrIoKGA0eaHdEmMM7pLelNidUOVIwV1NKRlE3TFIxWVI1QTA1OVJROUg3Ni4u"
										target="_blank" rel="noopener noreferrer"
										class="link-btn"
										attr.aria-label="{{'activity-editor-new_ai-markers-modal-request-feedback-link'| translate}}"
										translate="activity-editor-new_ai-markers-modal-request-feedback-link">
									</a>
								</span>
							</div>
						</ng-container>
					</div>
				</ng-container>
				<ng-template #loading>
					<span class="loading-container">
						<span class="ficon-spinner ficon-spin" aria-live="polite"
							  attr.aria-label="{{'common_loading'| translate}}"></span>
					</span>
				</ng-template>
				<div class="validation-error" *ngIf="(selectedCount$ | async) > AiMarkersLimit"
					 translate="activity-editor-new_ai-markers-modal-validation-max_limit"
					 [translateParams]="{ limit: AiMarkersLimit }">
				</div>
			</div>
			<ng-template #aiConfig>
				<div class="goreact-modal-body new-style" [ngClass]="{ 'collapsed': (showAi$ | async) === false }">
					<div>{{ 'activity-editor-new_ai-markers-modal-sub-title' | translate }}</div>
					<hr *ngIf="aiLanguageFlag"/>
					<ng-container *ngIf="aiLanguageFlag && (loading$ | async) === false">
						<div class="section-container transcript-container">
							<div>
								<strong>{{ 'feedback-session-feedback-display_transcript-header' | translate }}</strong>
							</div>
							<span class="transcript-language">
								<mat-form-field goSelect>
									<mat-label>{{ 'activity-editor-new_ai-markers-modal-transcript-language' | translate }}</mat-label>
									<mat-select
										disableOptionCentering
										panelClass="offsetPanel"
										[ngModel]="selectedLanguage$ | async"
										(ngModelChange)="selectedLanguage$.next($event)">
										<mat-option
											*ngFor="let language of languages$ | async"
											[value]="language">
											{{ language.language_name }}
										</mat-option>
									</mat-select>
									<mat-icon matIconSuffix class="ficon-app-chevron-down"></mat-icon>
								</mat-form-field>
							</span>
						</div>
					</ng-container>
					<ng-container *ngIf="(loading$ | async) === false; else loading">
						<div class="section-container markers-container"
							 [ngClass]="{'has-error': (selectedCount$ | async) > AiMarkersLimit}">
							<div class="container-header">
								<strong class="ai-markers-header">{{ 'activity-editor-new_ai-markers-modal-ai-markers' | translate }}</strong>
								<div *ngIf="(useTypes$ | async) && (showAi$ | async)" class="use-types-container">
									<mat-form-field goSelect>
										<mat-label>{{ 'activity-editor-new_ai-markers-modal-use-type' | translate }}</mat-label>
										<mat-select
											disableOptionCentering
											panelClass="offsetPanel ai-marker-use-type-panel"
											[ngModel]="useTypeFilter$ | async"
											(selectionChange)="useTypeFilter$.next($event.value)">
											<mat-option
												*ngFor="let u of useTypes$ | async"
												[value]="u.use_type_id">
												{{ u.name }}
											</mat-option>
										</mat-select>
										<mat-icon matIconSuffix class="ficon-app-chevron-down"></mat-icon>
									</mat-form-field>
									<span class="selected-count"
										 *ngIf="(selectedCount$ | async) > 0"
										 [ngClass]="{'has-error': (selectedCount$ | async) > AiMarkersLimit }">({{ selectedCount$ | async }})</span>
								</div>
							</div>
							<div class="container-body">
								<div class="description-container">
									<p translate="activity-editor-new_ai-markers-modal-description"
									[translateParams]="{ limit: AiMarkersLimit }">
									</p>
									<div *teaseWall="toggleTeaseConfig; of: loading$">
										<mat-slide-toggle
											[hideIcon]="true"
											(change)="toggleAiMarkers($event)"
											[checked]="true"
											color="primary"
											class="ai-comments-toggle">
											<span *ngIf="showAi$ | async">{{ 'common_on' | translate }}</span>
											<span *ngIf="(showAi$ | async) === false">{{ 'common_off' | translate }}</span>
										</mat-slide-toggle>
									</div>
								</div>

								<ng-container *ngIf="showAi$ | async">
									<div class="category-accordion" *ngFor="let category of uniqueCategories$ | async" [ngClass]="{'expanded': (expandedCategories$ | async).has(category.id)}">
										<div class="category-accordion-header" (click)="toggleCategory(category)">
											<div class="category-header-left">
												<div class="accordion-caret">
													<i [ngClass]="{'ficon-app-chevron-down': (expandedCategories$ | async).has(category.id), 'ficon-app-chevron-right': !(expandedCategories$ | async).has(category.id)}"></i>
												</div>
												<span class="category-icon">
													<i
														[attr.data-icon]="category.icon"
														[ngStyle]="{
															'color': getCategoryColor(category.color),
															'--icon-content': '\'\\' + (category.icon) + '\''
														}"></i>
												</span>
												<span class="category-name">{{category.name}}</span>
											</div>
											<div class="category-header-right">
												<button
													*ngIf="(expandedCategories$ | async).has(category.id) && !shouldTease"
													class="link-btn select-all-btn"
													[translate]="(isAllSelectedInCategory(category) | async) ? 'library-collections_multi-select-none' : 'library-collections_multi-select-all'"
													(click)="selectCategoryPrompts($event, category)">
												</button>
												<span class="category-count" *ngIf="(countByCategory$(category) | async) > 0">{{ countByCategory$(category) | async }}</span>
											</div>
										</div>
										<div class="category-accordion-content" *ngIf="(expandedCategories$ | async).has(category.id)">
											<div class="markers" [style.overflow-y]="shouldTease ? 'hidden':'auto'">
												<div class="marker-item" *ngFor="let prompt of getPromptsByCategory(category) | async">
													<ng-container *ngIf="!shouldTease">
														<mat-checkbox
															color="primary"
															[checked]="(checkedIds$ | async).has(prompt.id)"
															(change)="selectPrompt($event.checked, prompt)"
															aria-label="{{ markerAriaLabel(prompt) }}">
															<marker
																[marker]="markerInput(prompt)"
																[aiStyle]="true"
																[withName]="true">
															</marker>
															<div class="prompt-description">
																<i class="ficon-app-information-outline"
																[matTooltip]="prompt.description"
																matTooltipPosition="above"></i>
															</div>
														</mat-checkbox>
													</ng-container>

													<ng-container *ngIf="shouldTease">
														<div class="teased-marker-item">
															<div *teaseWall="checkboxTeaseConfig; of: loading$">
																<mat-checkbox
																	color="primary"
																	class="checkbox-to-blur"
																	[checked]="(checkedIds$ | async).has(prompt.id)"
																	[disabled]="true"
																	aria-label="{{ markerAriaLabel(prompt) }}">
																</mat-checkbox>
															</div>
															<div class="marker-and-description">
																<marker
																	[marker]="markerInput(prompt)"
																	[aiStyle]="true"
																	[withName]="true">
																</marker>
															</div>
														</div>
													</ng-container>
												</div>
											</div>
										</div>
									</div>

									<div *ngIf="!shouldTease" class="ai-marker-form-link">
										<span>
											<i class="ficon-lightbulb-o"></i>
											{{ 'activity-editor-new_ai-markers-modal-request-feedback-text' | translate }}
											<a
												href="https://forms.office.com/Pages/ResponsePage.aspx?id=pc7Ek96TuEyKKMAbn5USrIoKGA0eaHdEmMM7pLelNidUOVIwV1NKRlE3TFIxWVI1QTA1OVJROUg3Ni4u"
												target="_blank" rel="noopener noreferrer"
												class="link-btn"
												attr.aria-label="{{'activity-editor-new_ai-markers-modal-request-feedback-link'| translate}}"
												translate="activity-editor-new_ai-markers-modal-request-feedback-link">
											</a>
										</span>
									</div>
								</ng-container>
							</div>
						</div>
					</ng-container>
					<ng-template #loading>
						<span class="loading-container">
							<span class="ficon-spinner ficon-spin" aria-live="polite"
								  attr.aria-label="{{'common_loading'| translate}}"></span>
						</span>
					</ng-template>
					<div class="validation-error" *ngIf="(selectedCount$ | async) > AiMarkersLimit"
						 translate="activity-editor-new_ai-markers-modal-validation-max_limit"
						 [translateParams]="{ limit: AiMarkersLimit }">
					</div>
				</div>
			</ng-template>
			<div class="goreact-modal-footer">
				<a *ngIf="shouldTease"
				   [attr.href]="aiMarkerTeaseConfig.secondaryLink"
				   target="_blank"
				   rel="noopener noreferrer"
				   class="link-btn learn-more-link">
					{{ 'access_denied-learn-more' | translate }}
				</a>
				<button class="tertiary-btn cancel-btn" (click)="cancel()" translate="common_cancel"></button>
				<!-- We want to trigger the tease wall button using another button,
				so hide this tease wall button while still keeping it on the DOM -->
				<ng-container *ngIf="shouldTease">
					<div *teaseWall="aiMarkerTeaseConfig" style="display: none;"></div>
				</ng-container>
				@if (!shouldTease || aiMarkerTeaseConfig.promptAction) {
					<button class="primary-btn save-btn" (click)="handleSaveClick()">
						{{ shouldTease ? (aiMarkerTeaseConfig.translationKey | translate) : ('common_save-and-close' | translate) }}
					</button>
				}
			</div>
		</section>
	</div>
</div>
